package dev.danko.roblox_craft_ai.shared.model

import kotlinx.serialization.Serializable

@Serializable
enum class ChatMessageRole {
    USER,
    ASSISTANT,
    SYSTEM
}

@Serializable
data class ChatMessage(
    val id: String,
    val role: ChatMessageRole,
    val content: String,
    val timestamp: Long = 0L,
    val diffUnified: String? = null,
    val revisionNumber: Int? = null,
    val applied: Boolean = false,
    val updatedCode: String? = null,
    val filePath: String? = null
)

@Serializable
data class RefactorRequest(
    val assetId: String,
    val instruction: String,
    val activeFilePath: String? = null,
    val selectedCodeSnippet: String? = null,
    val preferredProviderId: String? = null
)

@Serializable
data class RefactorResponse(
    val assetId: String,
    val explanation: String,
    val updatedCode: String,
    val diffUnified: String,
    val revision: AssetRevision,
    val status: GenerationStatus = GenerationStatus.READY,
    val chatMessage: ChatMessage
)

@Serializable
data class RollbackRequest(
    val assetId: String,
    val targetRevisionNumber: Int
)

@Serializable
data class RollbackResponse(
    val assetId: String,
    val currentRevisionNumber: Int,
    val restoredCode: String,
    val success: Boolean,
    val message: String
)
